<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer7">
      <b-row>
        <b-col class="col-12">
          <h4>Please Read This Important Information</h4>

          <ul v-if="!this.form.PayerImpText">
            <li class="p-1">I must keep both Hospital (Part A) and Medical (Part B) to stay in {{ form.PayerName }}.
            </li>
            <li class="p-1">Part D plans insert: I must keep Hospital (Part A) or Medical (Part B) to stay in
              {{ form.PayerName }}.
            </li>
            <li class="p-1">By joining this Medicare Advantage Plan or Medicare Prescription Drug Plan, I acknowledge
              that {{ form.PayerName }} will share my information with Medicare, who may use it to track my enrollment,
              to make
              payments, and for other purposes allowed by Federal law that authorize the collection of this information
              (see Privacy Act Statement below).
            </li>
            <li class="p-1">Your response to this form is voluntary. However, failure to respond may affect enrollment
              in the plan.
            </li>
            <li class="p-1">The information on this enrollment form is correct to the best of my knowledge. I understand
              that if I
              intentionally provide false information on this form, I will be disenrolled from the plan.
            </li>
            <li class="p-1">I understand that people with Medicare are generally not covered under Medicare while out of
              the
              country, except for limited coverage near the U.S. border.
            </li>
            <li class="p-1">I understand that when my {{ form.PayerName }} coverage begins, I must get all of my medical
              and
              prescription drug benefits from {{ form.PayerName }}. Benefits and services provided by
              {{ form.PayerName }} and
              contained in my {{ form.PayerName }} “Evidence of Coverage” document (also known as a member
              contract or subscriber agreement) will be covered. Neither Medicare nor {{ form.PayerName }} will pay for
              benefits or services that are not covered.
            </li>
            <li class="p-1">I understand that my signature (or the signature of the person legally authorized to act on
              my behalf)
              on this application means that I have read and understand the contents of this application. If signed by
              an authorized representative (as described on previous page), this signature certifies that:<br>
              1) This person is authorized under State law to complete this enrollment, and<br>
              2) Documentation of this authority is available upon request by Medicare.
            </li>
          </ul>
          <span v-html="this.form.PayerImpText" v-if="this.form.PayerImpText">
          </span>
          <h5>PRIVACY ACT STATEMENT</h5>
          <span v-html="this.form.PayerPrivacyPolicy" v-if="this.form.PayerPrivacyPolicy"></span>
          <span v-if="!this.form.PayerPrivacyPolicy">The Centers for Medicare & Medicaid Services (CMS) collects information from Medicare plans to track beneficiary enrollment in Medicare Advantage (MA) or
          Prescription Drug Plans (PDP), improve care, and for the payment of Medicare benefits. Sections 1851 and 1860D-1 of the Social Security Act and 42 CFR §§
          422.50, 422.60, 423.30 and 423.32 authorize the collection of this information. CMS may use, disclose and exchange enrollment data from Medicare beneficiaries
          as specified in the System of Records Notice (SORN) "Medicare Advantage".</span>
        </b-col>
        <b-col class="col-12">
          <b-form-group>
            <validation-provider
                rules="required"
                :bails="false"
                v-slot="{ classes, errors }"
                class="col-3 p-0 mr-1"
                vid="acknowledgeAttest"
                name="selection"
            >
              <div style="font-weight:bold">
                <b-form-radio-group :key="enrollSel"
                    id="acknowledgeAttest"
                    class="pt-2"
                    :options="[{value:'acknowledge',text:'I am the person listed on this enrollment form or I am simply helping to complete this enrollment form. I acknowledge that I have read the above information and fully understand the contents of the application.'},
                      {value:'attest',text: 'I am the representative authorized to complete this application. I attest that I have such authority to make the enrollment request and proof of this authority is available upon request to '+ form.PayerPlan+' Plan or CMS.'}]"
                    ref="acknowledgeAttest"
                    v-model="form.acknowledgeAttest"
                    @input="removeDetails(form.acknowledgeAttest,['attstFirstName','attstLastName','attstAddr','attstPhNum','attstEnrollRel'])"
                ></b-form-radio-group>
                <div class="control" :class="classes">
                  <span>{{ errors[0] ? 'Please select an option to proceed.' : '' }}</span>
                </div>
              </div>
              <hr/>
              <span v-if="form.acknowledgeAttest==='acknowledge'">
                <b-form-group
                    label-cols-sm="3"
                    label="First Name "
                    label-for="attstFirstName"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
                >
                  <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-3 p-0 "
                      vid="attstFirstName"
                      name="First Name"
                  >
                    <div class="control" :class="classes">
                      <b-form-input
                          id="attstFirstName"
                          v-model="form.attstFirstName"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                          ref="attstFirstName"
                          placeholder="First Name"
                      ></b-form-input>
                      <span>{{ errors[0] }}</span>
                    </div>
                    <div class="control invalid">
                      <span class="test" v-if="form.attstFirstName && form.attstFirstName!='' && (form.MemberFname.toUpperCase()!=form.attstFirstName.toUpperCase())">First Name does not match with First Name provided in Personal information section.</span>
                    </div>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                    label-cols-sm="3"
                    label="Last Name "
                    label-for="attstLastName"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
                >
                  <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-3 p-0 "
                      vid="attstLastName"
                      name="Last Name"
                  >
                    <div class="control" :class="classes">
                      <b-form-input
                          id="attstLastName"
                          v-model="form.attstLastName"
                          ref="attstLastName"
                          placeholder="Last Name"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      ></b-form-input>
                      <span>{{ errors[0] }}</span>
                    </div>
                    <div class="control invalid">
                      <span v-if="form.attstLastName && form.attstLastName!='' && (form.MemberLname.toUpperCase()!=form.attstLastName.toUpperCase())">Last Name does not match with Last Name provided in Personal information section.</span>
                    </div>
                  </validation-provider>
                </b-form-group>
                <b-form-group class="mb-1" id="dob"
                              label-cols-sm="3"
                              label="Date "
                              label-for="attstDate"
                              label-class="font-weight-bold pt-0 custom-req">
                  <ValidationProvider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="Date"
                      class="p-0 col-12"
                      vid="dob"
                  >
                    <div class="control" :class="classes">
                      <b-form-datepicker
                          id="example-i18n-picker"
                          v-model="form.ApplicationDate"
                          :locale="'en-US'"
                          placeholder="Select Date"
                          :show-decade-nav="true"
                          :date-format-options="{ year: 'numeric', month: 'short' }"
                          class="mb-0 col-xs-8 col-sm-8 col-md-8 col-lg-4"
                          ref="dob"
                          :min="maxApplicationDate"
                          readonly
                      ></b-form-datepicker>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </span>
              <span v-if="form.acknowledgeAttest==='attest'">
                <b-form-group
                    label-cols-sm="3"
                    label="First Name "
                    label-for="attstFirstName"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
                >
                  <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-3 p-0 "
                      vid="attstFirstName"
                      name="First Name"
                  >
                    <div class="control" :class="classes">
                      <b-form-input
                          id="attstFirstName"
                          v-model="form.attstFirstName"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                          ref="attstFirstName"
                          placeholder="First Name"
                      ></b-form-input>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                    label-cols-sm="3"
                    label="Last Name "
                    label-for="attstLastName"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
                >
                  <validation-provider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes, errors }"
                      class="col-3 p-0 "
                      vid="attstLastName"
                      name="Last Name"
                  >
                    <div class="control" :class="classes">
                      <b-form-input
                          id="attstLastName"
                          v-model="form.attstLastName"
                          ref="attstLastName"
                          placeholder="Last Name"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                      ></b-form-input>
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </b-form-group>
<!--                <b-form-group-->
<!--                    label-cols-sm="3"-->
<!--                    label="Address "-->
<!--                    label-for="attstAddr"-->
<!--                    label-class="font-weight-bold pt-0 custom-req"-->
<!--                    class="mb-2"-->
<!--                >-->
<!--                  <validation-provider-->
<!--                      rules="required"-->
<!--                      :bails="false"-->
<!--                      v-slot="{ classes, errors }"-->
<!--                      class="col-3 p-0 "-->
<!--                      vid="attstAddr"-->
<!--                      name="Address"-->
<!--                  >-->
<!--                    <div class="control" :class="classes">-->
<!--                      <b-form-input-->
<!--                          id="attstAddr"-->
<!--                          v-model="form.attstAddr"-->
<!--                          ref="attstAddr"-->
<!--                          placeholder="Address"-->
<!--                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"-->
<!--                      ></b-form-input>-->
<!--                      <span>{{ errors[0] }}</span>-->
<!--                    </div>-->
<!--                  </validation-provider>-->
<!--                </b-form-group>-->
                <div :key="attsAddComponent">
            <b-form-group
                    label-cols-sm="3"
                    label="Street 1 "
                    label-for="GuardianAdd"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
            >
              <ValidationProvider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="Street 1"
                      class="col-3 p-0"
                      vid="graddr"
              >
                <div class="control" :class="classes">
                  <b-form-input
                          id="GuardianAdd"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                          ref="praddr"
                          placeholder="Street 1"
                          v-model="form.attstStreet1"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                    label-cols-sm="3"
                    label="Street 2 "
                    label-for="attstStreet2"
                    label-class="font-weight-bold pt-0"
                    class="mb-2"
            >
              <ValidationProvider
                      v-slot="{ classes, errors }"
                      name="Street 2"
                      class="col-3 p-0"
                      vid="attstStreet2"
              >
                <div class="control" :class="classes">
                  <b-form-input
                          id="attstStreet2"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                          ref="attstStreet2"
                          v-model="form.attstStreet2"
                          placeholder="Street 2"
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                    label-cols-sm="3"
                    label="Zip Code "
                    label-for="attZip"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
            >
              <ValidationProvider
                      rules="required|zipCodValid"
                      v-slot="{ classes, errors }"
                      name="Zip Code"
                      class="col-3 p-0"
                      vid="attZip"
              >
                <div class="control" :class="classes">
                  <b-form-input id="attZip" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="attZip"
                                v-model="form.attstZip" @input="getAttsZipDetails(form.attstZip)"
                                placeholder="Zip Code"
                                @blur="attsAddComponent += 1;"></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                    label-cols-sm="3"
                    label="City "
                    label-for="attCity"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
            >
              <ValidationProvider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="City"
                      class="col-3 p-0"
                      vid="prcity"
              >
                <div class="control" :class="classes">
                  <b-form-input id="attCity" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="prcity"
                                placeholder="City"
                                v-model="form.attstCity" debounce="500" disabled></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                    label-cols-sm="3"
                    label="State "
                    label-for="attstate"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
            >
              <ValidationProvider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="State"
                      class="col-3 p-0"
                      vid="attstate"
              >
                <div class="control" :class="classes">
                  <b-form-input
                          id="input-1"
                          v-model="form.attstState"
                          class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                          placeholder="State"
                          ref="attstate"
                          disabled
                  ></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
                    label-cols-sm="3"
                    label="County "
                    label-for="AttCounty"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
            >
              <ValidationProvider
                      rules="required"
                      v-slot="{ classes, errors }"
                      name="County"
                      class="col-3 p-0"
                      vid="AttCounty"
              >
                <div class="control" :class="classes">
                  <b-form-input id="AttCounty" class="col-xs-8 col-sm-8 col-md-8 col-lg-6" ref="przip"
                                placeholder="County"
                                v-model="form.attstCounty" disabled></b-form-input>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </div>
                <b-form-group
                    label-cols-sm="3"
                    label="Phone Number "
                    label-for="attstPhNum"
                    label-class="font-weight-bold pt-0 custom-req"
                    class="mb-2"
                >
                      <validation-provider
                          rules="required|min-phnum"
                          :bails="false"
                          v-slot="{ classes, errors }"
                          class="col-3 p-0 "
                          vid="attstPhNum"
                          name="Phone Number"
                      >
                        <div class="control" :class="classes">
                          <b-form-input
                              id="attstPhNum"
                              v-model="form.attstPhNum"
                              ref="attstPhNum"
                              class="col-xs-8 col-sm-8 col-md-8 col-lg-4"
                              v-mask="'(###)-###-####'"
                              placeholder="Phone Number"
                          ></b-form-input>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                        label-cols-sm="3"
                        label="Relationship to Enrollee "
                        label-for="attstEnrollRel"
                        label-class="font-weight-bold pt-0 custom-req"
                        class="mb-2"
                    >
                      <validation-provider
                          rules="required"
                          :bails="false"
                          v-slot="{ classes, errors }"
                          class="col-3 p-0"
                          vid="attstEnrollRel"
                          name="Relationship to Enrollee"
                      >
                        <div class="control" :class="classes">
                          <b-form-select id="attstEnrollRel" ref="attstEnrollRel" v-model="form.attstEnrollRel"
                                         :options="relncodes" size="sm"
                                         class="col-xs-8 col-sm-8 col-md-8 col-lg-4"></b-form-select>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group class="mb-1" id="aatstdate" label-cols-sm="3"
                                  label="Date "
                                  label-for="attstDate"
                                  label-class="font-weight-bold pt-0 custom-req">
                      <ValidationProvider
                          rules="required"
                          v-slot="{ classes, errors }"
                          name="Date"
                          class="p-0 col-12"
                          vid="dob"
                      >
                        <div class="control" :class="classes">
                          <b-form-datepicker
                              id="example-i18n-picker"
                              v-model="form.ApplicationDate"
                              :locale="'en-US'"
                              placeholder="Select Date"
                              :show-decade-nav="true"
                              :date-format-options="{ year: 'numeric', month: 'short' }"
                              class="mb-0 col-xs-8 col-sm-8 col-md-8 col-lg-4"
                              ref="dob"
                              :min="maxApplicationDate"
                              readonly
                          ></b-form-datepicker>
                          <span>{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </span>
            </validation-provider>
          </b-form-group>
          <br/>
          <p>By clicking "Enroll Now", you will be enrolled if approved by the Centers for Medicare & Medicaid Services
            and will receive notice of acceptance or denial following submission of the enrollment form to CMS.</p>
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";
import MedicareLeadsService from "../../MedicareLeadsService"
export default {
  name: "OnlineEnrollment",
  components: {},
  data() {
    return {
      dispFlag: true,
      enrollSel: 10,
      maxApplicationDate: new Date(),
      firstNameValidationObj: {},
      lastNameValidationObj: {},
      attsAddComponent: 0
    };
  },
  props: {
    form: Object,
    relncodes: Array
  },
  methods: {
    async removeDetails(checkVal) {
      console.log("checkVal", checkVal);
      console.log("this.form.acknowledgeAttest", this.form.acknowledgeAttest);
      if (this.form.acknowledgeAttest === 'acknowledge') {
        this.form.attstEnrollRel = '18';
      } else {
        this.form.attstEnrollRel = undefined;
      }


    },
    async getAttsZipDetails(val) {
      this.zipDetails = [];
      if (val && val.length > 4) {
        this.zipDetails = await MedicareLeadsService.getZipCodeDetails(val);
        if (this.zipDetails.length > 0) {
          this.form.attstCity = this.zipDetails[0].CityName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CityName.toLowerCase().slice(1);
          this.form.attstStateName = this.zipDetails[0].StateName;
          this.form.attstState = this.zipDetails[0].StateAbbr;
          this.form.attstCounty = this.zipDetails[0].CountyName ? this.zipDetails[0].CountyName.toLowerCase().charAt(0).toUpperCase() + this.zipDetails[0].CountyName.toLowerCase().slice(1) : '';
          this.addrComponent += 1;
        } else {
          this.form.attstCity = '';
          this.form.attstState = '';
          this.form.attstCounty = '';
        }
      }else {
        this.form.attstCity = '';
        this.form.attstState = '';
        this.form.attstCounty = '';
      }

    }
  },
  async created() {
    this.form.acknowledgeAttest = 'acknowledge';
    this.enrollSel += 1;
    this.form.attstEnrollRel = '18';
    this.form.ApplicationDate = new Date();
  }
};
</script>
